module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add-quote-body",
    attrs: {
      "id": "addQuote"
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "esc", 27)) { return; }
        _vm.hideAddQuote($event)
      }
    }
  }, [_c('form', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.quote),
      expression: "form.quote"
    }],
    ref: "textQuote",
    staticClass: "megainput",
    class: {
      error_box: _vm.error.textError
    },
    attrs: {
      "name": "quote",
      "placeholder": "What quote you want to add?"
    },
    domProps: {
      "value": _vm._s(_vm.form.quote)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.quote = $event.target.value
      }
    }
  }), (_vm.error.textError) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error.textError))]) : _vm._e(), _c('div', {
    staticClass: "add-author"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.author),
      expression: "form.author"
    }],
    staticClass: "input-select",
    class: {
      error_box: _vm.error.authorError
    },
    attrs: {
      "name": "author"
    },
    on: {
      "change": function($event) {
        _vm.form.author = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.external.id
    }
  }, [_vm._v(_vm._s(_vm.external.name))]), _vm._l((_vm.getAuthors), function(author) {
    return _c('option', {
      domProps: {
        "value": author.id
      }
    }, [_vm._v(_vm._s(author.name))])
  })], 2), _c('div', {
    staticClass: "external",
    class: {
      error_box: _vm.error.externalError
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.externalAuthor),
      expression: "form.externalAuthor"
    }],
    staticClass: "input-text",
    attrs: {
      "name": "externalAuthor",
      "type": "text",
      "placeholder": "Set his or her name",
      "disabled": _vm.externalDisabled
    },
    domProps: {
      "value": _vm._s(_vm.form.externalAuthor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.externalAuthor = $event.target.value
      }
    }
  }), (_vm.error.externalError) ? _c('p', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error.externalError))]) : _vm._e()])]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.explanation),
      expression: "form.explanation"
    }],
    staticClass: "megainput comment",
    attrs: {
      "name": "explanation",
      "placeholder": "Some explanation?"
    },
    domProps: {
      "value": _vm._s(_vm.form.explanation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.explanation = $event.target.value
      }
    }
  }), _c('input', {
    staticClass: "btn-green",
    attrs: {
      "type": "button",
      "value": _vm.button
    },
    on: {
      "click": function($event) {
        _vm.saveQuote()
      }
    }
  }), _c('a', {
    staticClass: "close",
    attrs: {
      "id": "closeAddQuote"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.hideAddQuote()
      }
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "500",
      "height": "500",
      "viewBox": "0 0 500 500"
    }
  }, [_c('path', {
    attrs: {
      "d": "M254.832 499.517c-2.658.644-7.006.644-9.664 0-5.773-1.4-13.147-8.265-14.846-13.82-.64-2.095-1.136-50.682-1.102-107.97.034-57.29-.562-104.788-1.325-105.55-.763-.765-48.248-1.36-105.522-1.326-57.275.035-105.85-.46-107.944-1.102-2.096-.64-5.798-3.157-8.228-5.59-8.27-8.286-8.27-19.9 0-28.185 2.43-2.433 6.132-4.95 8.227-5.59 2.094-.642 50.668-1.138 107.943-1.103 57.274.034 104.76-.562 105.522-1.326.763-.763 1.36-48.26 1.325-105.55-.035-57.29.462-105.876 1.102-107.972.64-2.095 3.157-5.798 5.59-8.228 8.283-8.272 19.894-8.272 28.176 0 2.433 2.43 4.95 6.133 5.59 8.228.64 2.096 1.137 50.683 1.102 107.972-.034 57.29.562 104.787 1.325 105.55.763.764 48.248 1.36 105.523 1.326 57.274-.035 105.848.46 107.943 1.102 2.096.64 5.798 3.157 8.228 5.59 8.27 8.286 8.27 19.9 0 28.185-2.432 2.432-6.132 4.95-8.227 5.59-2.094.642-50.668 1.138-107.942 1.104-57.275-.034-104.76.562-105.523 1.326-.763.763-1.36 48.26-1.325 105.55.035 57.29-.462 105.876-1.102 107.972-1.7 5.554-9.073 12.42-14.846 13.82z"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9c77e1a4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/AddQuotes/AddQuotes.pug
// module id = 264
// module chunks = 2